// import { Form } from "react-bootstrap"
import { FaChevronLeft } from "react-icons/fa"
import { useNavigate, useParams } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import SecondaryButton from "../../components/subComponents/SecondaryButton"
import { RebootIcon, SelftestIcon, TransferIcon, UpdateFWIcon } from "../../icons/webSvg"
import PrimaryButton from "../../components/subComponents/PrimaryButton"
import { useCallback, useEffect, useState } from "react"
import { changeloaderState } from "../../store/loaderSlice"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../store/store"
import { request } from "../../services/request"

const Icon: any = FaChevronLeft

const LocationDeviceDetail: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const param = useParams()
  const [deviceDetail, setDeviceDetail] = useState<any>([])

  const getBack = () => {
    navigate(-1)
  }

  const fetchCustomerDetails = useCallback(async () => {
    try {
      dispatch(changeloaderState(true))
      const response = await request<any>({
        url: `/adminCommon/getSensorById/${param.id}`,
        method: "GET",
      })
      if (response.success) {
        setDeviceDetail(response.data)
      } else {
        toast.error("Failed to fetch customers: " + response.message)
      }
    } catch (error) {
      toast.error("Something went wrong")
    } finally {
      dispatch(changeloaderState(false))
    }
  }, [dispatch, param])

  useEffect(() => {
    fetchCustomerDetails()
  }, [fetchCustomerDetails])

  const calculateUptime = (testedAt?: string | Date) => {
    if (!testedAt) return "-";

    const lastContact = new Date(testedAt);
    const now = new Date();
    let diffMs = now.getTime() - lastContact.getTime();

    if (diffMs < 0) return "—"; // guard against future dates

    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    diffMs -= days * (1000 * 60 * 60 * 24);

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    diffMs -= hours * (1000 * 60 * 60);

    const minutes = Math.floor(diffMs / (1000 * 60));

    if (days > 0) {
      return `${days}d ${hours}h`;
    } else if (hours > 0) {
      return `${hours}h ${minutes}m`;
    } else {
      return `${minutes}m`;
    }
  };


  const handleReboot = async () => {
    try {
      const response = await request({
        url: `/sensorCommon/reboot/${param.id}`,
        method: "POST",
        headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" }
      })
      if (response.success) {
        fetchCustomerDetails()
        toast.success(response.message)
      } else {
        toast.error(response.message)
      }
    } catch (error: any) {
      toast.error(`${error.message}`)
    }
  }

  const handleRunSelfTest = async () => {
    try {
      const response = await request({
        url: `/sensorCommon/selfTest/${param.id}`,
        method: "POST",
        headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" }
      })
      if (response.success) {
        fetchCustomerDetails()
        toast.success(response.message)
      } else {
        toast.error(response.message)
      }
    } catch (error: any) {
      toast.error(`${error.message}`)
    }
  }
  const handleUpdateFW = async () => {
    try {
      const response = await request({
        url: `/sensorCommon/updateFW/${param.id}`,
        method: "POST",
        headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" }
      })
      if (response.success) {
        fetchCustomerDetails()
        toast.success(response.message)
      } else {
        toast.error(response.message)
      }
    } catch (error: any) {
      toast.error(`${error.message}`)
    }
  }
  const handleTransferOwner = async () => {
    try {
      const response = await request({
        url: `/sensorCommon/ownerTransfer/${param.id}`,
        method: "POST",
        headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" }
      })
      if (response.success) {
        fetchCustomerDetails()
        toast.success(response.message)
      } else {
        toast.error(response.message)
      }
    } catch (error: any) {
      toast.error(`${error.message}`)
    }
  }

  const handleMoveToInventory = async () => {
    try {
      const response = await request({
        url: `/sensorCommon/moveToInventory/${param.id}`,
        method: "POST",
        headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" }
      })
      if (response.success) {
        fetchCustomerDetails()
        toast.success(response.message)
      } else {
        toast.error(response.message)
      }
    } catch (error: any) {
      toast.error(`${error.message}`)
    }
  }

  const handleReplace = async () => {
    try {
      const response = await request({
        url: `/sensorCommon/replace/${param.id}`,
        method: "POST",
        headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" }
      })
      if (response.success) {
        fetchCustomerDetails()
        toast.success(response.message)
      } else {
        toast.error(response.message)
      }
    } catch (error: any) {
      toast.error(`${error.message}`)
    }
  }

  const handleDeleteSensor = async () => {
    try {
      const response = await request({
        url: `/sensorCommon/deleteSensor/${param.id}`,
        method: "DELETE",
        headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" }
      })
      if (response.success) {
        fetchCustomerDetails()
        toast.success(response.message)
      } else {
        toast.error(response.message)
      }
    } catch (error: any) {
      toast.error(`${error.message}`)
    }
  }

  const handleDeactivateSensor = async () => {
    try {
      const response = await request({
        url: `/sensorCommon/deactivate/${param.id}`,
        method: "POST",
        headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" }
      })
      if (response.success) {
        fetchCustomerDetails()
        toast.success(response.message)
      } else {
        toast.error(response.message)
      }
    } catch (error: any) {
      toast.error(`${error.message}`)
    }
  }

  const handleClearAlert = async () => {
    try {
      const response = await request({
        url: `/adminCommon/sensorClear`,
        method: "POST",
        headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" },
        data: [`${param.id}`],
      })
      if (response.success) {
        fetchCustomerDetails()
        toast.success(response.message)
      } else {
        toast.error(response.message)
      }
    } catch (error: any) {
      toast.error(`${error.message}`)
    }
  }


  return (
    <section className='dashboard-section dashboard-item'>
      <ToastContainer position='top-right' autoClose={2000} theme='light' />
      <div className='container'>
        <div className='row'>
          <div className='col-12 mb-3'>
            <div className='d-flex gap-2 align-items-center customer-detail-line'>
              <button onClick={getBack} className='d-flex align-items-center p-0 mr-2'>
                <Icon size={20} />
              </button>
              <div className='dashboard-table-title-section'>
                <h2 className='mb-0'>Sensor Details</h2>
              </div>
            </div>
          </div>
        </div>

        <div className='row mb-3'>
          <div className='col-12'>
            <div className='deviceDetails-header'>
              <div className='d-flex flex-wrap align-items-center'>
                <div className='me-4'>
                  <h6 className='d-inline mb-0'>Device:</h6>
                  <span className='location-details-font ms-1'>{deviceDetail[0]?.sensor_id}</span>
                </div>

                <div className='me-4'>
                  <h6 className='d-inline mb-0'>Status:</h6>
                  <span
                    // className={`ms-2 rounded-circle ${deviceDetail[0]?.status === "1" ? "bg-success" : "bg-danger"}`}
                    className={`ms-2 rounded-circle d-inline-block ${deviceDetail[0]?.status === "2"
                        ? "bg-success"
                        : deviceDetail[0]?.status === "1"
                          ? "bg-warning"
                          : deviceDetail[0]?.status === "3"
                            ? "bg-con-error"
                            : "bg-danger"
                      }`}
                    style={{ width: "10px", height: "11px", display: "inline-block" }}
                  ></span>
                  <span className='location-details-font ms-1'>
                    {/* {deviceDetail[0]?.status === "1" ? "Active" : "Offline"} */}
                    {deviceDetail[0]?.status === "2"
                      ? "Active"
                      : deviceDetail[0]?.status === "1"
                        ? "ALERT"
                        : deviceDetail[0]?.status === "3"
                          ? "Connection Error"
                          : "Offline"}
                  </span>
                </div>

                <div className='me-4'>
                  <h6 className='d-inline mb-0'>Model:</h6>
                  <span className='location-details-font ms-1'>{deviceDetail[0]?.sensorDetails?.model}</span>
                  {/* (<span className="location-details-font">{location.contact_email}</span>) */}
                </div>

                <div className='me-4'>
                  <h6 className='d-inline mb-0'>Owner:</h6>
                  <span className='location-details-font ms-1'>
                    {`${deviceDetail[0]?.createdlocationUserAccount?.first_name ?? ""} ${deviceDetail[0]?.createdlocationUserAccount?.last_name ?? ""}`.trim()}
                  </span>
                </div>

              </div>

              <div className='d-flex flex-wrap mt-2'>
                <div className='me-4'>
                  <h6 className='d-inline mb-0'>Location:</h6>
                  <span className='location-details-font ms-1'>{deviceDetail[0]?.locationsSensor?.address}</span>
                </div>
                <div className='me-4'>
                  <h6 className='d-inline mb-0'>Installed:</h6>
                  <span className='location-details-font ms-1'>
                    {deviceDetail[0]?.createdAt
                      ? new Intl.DateTimeFormat("en-CA", {
                        timeZone: "America/New_York", // optional, remove if you just want UTC
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      }).format(new Date(deviceDetail[0]?.createdAt))
                      : "-"}
                  </span>
                </div>
                <div className='me-4'>
                  <h6 className='d-inline mb-0'>Firmware:</h6>
                  <span className='location-details-font ms-1'>{deviceDetail[0]?.sensorDetails?.firmware}</span>
                </div>
                <div className='me-4'>
                  <h6 className='d-inline mb-0'>Created:</h6>
                  <span className='location-details-font ms-1'>
                    {new Date(deviceDetail[0]?.createdAt).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                      timeZoneName: "short",
                      timeZone: "America/New_York",
                    })}
                  </span>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className='row mb-3'>
          <div className='col-12'>
            <div className='deviceDetails-overview-section'>
              <h5 className='mb-3'>Overview</h5>
              <div className='row'>
                <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                  <div className='Overview-details-card'>
                    <h6>Health</h6>
                    <div>
                      {deviceDetail[0]?.sensorDetails && Object.entries(deviceDetail[0]?.sensorDetails?.health).map(([key, value], i) => (
                        <div className="location-details-font Overview-detail-health text-capitalize" key={i}>
                          <span
                            className={`me-2 rounded-circle ${value === 1 ? "bg-success" : "bg-danger"}`}
                            style={{ width: "10px", height: "10px", display: "inline-block" }}
                          ></span>
                          <span>
                            {key} {value === 1 ? "OK" : "FAIL"}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                  <div className='Overview-details-card'>
                    <h6>Uplink (WAN)</h6>
                    {deviceDetail[0]?.sensorDetails?.uplink?.ip && <div className='location-details-font'>IP: {deviceDetail[0]?.sensorDetails?.uplink?.ip}</div>}
                    {deviceDetail[0]?.sensorDetails?.uplink?.backhaul && <div className='location-details-font'>
                      Backhaul: {deviceDetail[0]?.sensorDetails?.uplink?.backhaul}
                    </div>}
                    {deviceDetail[0]?.sensorDetails?.uplink?.rssi && <div className='location-details-font'>
                      RSSI: {deviceDetail[0]?.sensorDetails?.uplink?.rssi}
                    </div>}
                    {deviceDetail[0]?.testedAt && <div className='location-details-font'>
                      Uptime: {calculateUptime(deviceDetail[0]?.testedAt)}
                    </div>}
                  </div>
                </div>
                <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                  <div className='Overview-details-card'>
                    <h6>Mesh</h6>
                    {deviceDetail[0]?.sensorDetails?.mesh?.role && <div className='location-details-font'>
                      Role: {deviceDetail[0]?.sensorDetails?.mesh?.role}
                    </div>}
                    {deviceDetail[0]?.sensorDetails?.mesh?.ipv6 && <div className='location-details-font'>
                      IPv6: {deviceDetail[0]?.sensorDetails?.mesh?.ipv6}
                    </div>}
                    {(deviceDetail[0]?.sensorDetails?.mesh?.pan || deviceDetail[0]?.sensorDetails?.mesh?.channel) && <div className='location-details-font'>
                      {deviceDetail[0]?.sensorDetails?.mesh?.pan && <span> PAN: {deviceDetail[0]?.sensorDetails?.mesh?.pan}</span>}&nbsp; |&nbsp;
                      {deviceDetail[0]?.sensorDetails?.mesh?.channel && <span>Channel:{" "}
                        {deviceDetail[0]?.sensorDetails?.mesh?.channel}</span>}
                    </div>}
                    {deviceDetail[0]?.sensorDetails?.mesh?.leader && <div className='location-details-font'>
                      Leader: {deviceDetail[0]?.sensorDetails?.mesh?.leader}
                    </div>}
                  </div>
                </div>
                <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                  <div className='Overview-details-card'>
                    <h6>Actions</h6>
                    <SecondaryButton onClick={handleReboot} label="Reboot" icon={RebootIcon} className="OverviewDetails-actions-btn" />
                    <SecondaryButton onClick={handleRunSelfTest} label="Run Self-Test" icon={SelftestIcon} className="OverviewDetails-actions-btn" />
                    <SecondaryButton onClick={handleUpdateFW} label="Update FW" icon={UpdateFWIcon} className="OverviewDetails-actions-btn" />
                    <SecondaryButton onClick={handleTransferOwner} label="Transfer Owner" icon={TransferIcon} className="OverviewDetails-actions-btn" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Events Section */}
        <div className='row mb-3'>
          <div className='col-12'>
            <div className='deviceDetails-subCard'>
              <h5 className='mb-3'>Recent Events (last 24h)</h5>
              <div className="recent-event-list">
                {deviceDetail[0]?.sensorEvents?.map((event: any, i: number) => (
                  <div className='location-details-font' key={i}>
                    <>{new Date(event?.executeTime).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: false,
                      timeZoneName: "short",
                      timeZone: "America/New_York",
                    })}</>&nbsp; &nbsp; &nbsp; {event.eventName}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Diagnostics Section */}
        <div className='row mb-3'>
          <div className='col-12'>
            <div className='deviceDetails-subCard'>
              <h5 className='mb-3'>Diagnostics (quick view)</h5>
              {/* <p className='location-details-font'>
                CPU {deviceData.diagnostics.cpu}&nbsp; |&nbsp; RAM {deviceData.diagnostics.ram}
                &nbsp; |&nbsp; Disk {deviceData.diagnostics.disk}&nbsp; |&nbsp; Temp{" "}
                {deviceData.diagnostics.temp}&nbsp; |&nbsp; Packet Loss{" "}
                {deviceData.diagnostics.packetLoss}&nbsp; |&nbsp; Jitter{" "}
                {deviceData.diagnostics.jitter}
              </p> */}
              <p className="location-details-font">
                {deviceDetail[0]?.sensorDetails?.diagnostics?.cpu && <>CPU {deviceDetail[0]?.sensorDetails.diagnostics.cpu}&nbsp; |&nbsp;</>}
                {deviceDetail[0]?.sensorDetails?.diagnostics?.ram && <>RAM {deviceDetail[0]?.sensorDetails.diagnostics.ram}&nbsp; |&nbsp;</>}
                {deviceDetail[0]?.sensorDetails?.diagnostics?.disk && <>Disk {deviceDetail[0]?.sensorDetails.diagnostics.disk}&nbsp; |&nbsp;</>}
                {deviceDetail[0]?.sensorDetails?.diagnostics?.temp && <>Temp {deviceDetail[0]?.sensorDetails.diagnostics.temp}&nbsp; |&nbsp;</>}
                {deviceDetail[0]?.sensorDetails?.diagnostics?.packet_loss && <>Packet Loss {deviceDetail[0]?.sensorDetails.diagnostics.packet_loss}&nbsp; |&nbsp;</>}
                {deviceDetail[0]?.sensorDetails?.diagnostics?.jittle && <>Jitter {deviceDetail[0]?.sensorDetails.diagnostics.jittle}</>}
              </p>

            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="deviceDetails-footer">
              <div className="deviceDetails-footer-left">
                <PrimaryButton label="Deactivate" onClick={handleDeactivateSensor} />
                <PrimaryButton label="Move to Inventory" onClick={handleMoveToInventory} />
                <PrimaryButton label="Replace / RMA" onClick={handleReplace} />
                <PrimaryButton label="Delete" onClick={handleDeleteSensor} />
                <PrimaryButton label="Clear Alert" onClick={handleClearAlert} />
              </div>
              <div className="deviceDetails-footer-right">
                {deviceDetail[0]?.updatedAt && <p className="location-details-font">
                  Last Updated:{" "}
                  {new Intl.DateTimeFormat("en-CA", {
                    timeZone: "America/New_York", // EDT/EST depending on date
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  })
                    .format(new Date(deviceDetail[0]?.updatedAt))
                    .replace(",", "")}{" "}
                  EDT
                </p>}
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LocationDeviceDetail
